var render = function render(){var _vm=this,_c=_vm._self._c;return (this.order.getFirstEvent())?_c('div',[_c('div',{staticClass:"order-date"},[_vm._v("\n        "+_vm._s(this.app.mixins.MixinVue.methods.vue.methods.dateDayFullText(
                _vm.order.getFirstEvent().start_datetime,
                _vm.order.getFirstEvent().timezone,
                _vm.order.course.is_online
            ))+"\n        "+_vm._s(this.app.mixins.MixinVue.methods.vue.methods.dateDayNumber(
                _vm.order.getFirstEvent().start_datetime,
                _vm.order.getFirstEvent().timezone,
                _vm.order.course.is_online
            ))+"\n        "+_vm._s(this.app.mixins.MixinVue.methods.vue.methods.dateMonthAndYear(
                _vm.order.getFirstEvent().start_datetime,
                _vm.order.getFirstEvent().timezone,
                _vm.order.course.is_online
            ))+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"course-hours"},[_c('span',{domProps:{"innerHTML":_vm._s(
                this.app.mixins.MixinVue.methods.vue.methods.hours(
                    _vm.order.getFirstEvent().start_datetime,
                    _vm.order.getFirstEvent().end_datetime,
                    _vm.order.getFirstEvent().timezone,
                    _vm.order.course.is_online
                )
            )}}),_vm._v(" "),(_vm.order.course.is_online)?_c('span',{staticClass:"course-timezone"},[_vm._v("("+_vm._s(this.app.locale.getUserTimezone())+")")]):_vm._e()])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }